module.exports = __webpack_public_path__ + "img/desiging_for_behavior_change.e1722cc3.jpg";